module.exports = __webpack_public_path__ + "static/media/vehicle_in_out.922932ba.jpg";